/* eslint-disable */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ApiUrl } from "Services/Services";
import { MdAdd, MdClose, MdHistory } from "react-icons/md";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";

export default function Ingredients() {
  const [ingredients, setIngredients] = useState([]);
  const [logs, setLogs] = useState([]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showLogsModal, setShowLogsModal] = useState(false);
  const [editingIngredient, setEditingIngredient] = useState(null); // ✅ Track editing
  const [form, setForm] = useState({ name: "", quantity: "", unit: "" });

  // Pagination states
  const [currentIngredientPage, setCurrentIngredientPage] = useState(1);
  const [ingredientsPerPage] = useState(5);
  const [currentLogPage, setCurrentLogPage] = useState(1);
  const [logsPerPage] = useState(5);

  // Lock/unlock scroll when modal open
  useEffect(() => {
    document.body.style.overflow = showAddModal || showLogsModal ? "hidden" : "auto";
  }, [showAddModal, showLogsModal]);

  useEffect(() => {
    fetchIngredients();
  }, []);

  const fetchIngredients = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/ingredients`);
      setIngredients(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLogs = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/ingredients/logs`);
      setLogs(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const openLogsModal = () => {
    fetchLogs();
    setCurrentLogPage(1);
    setShowLogsModal(true);
  };

  // Open add modal for new ingredient
  const openAddModal = () => {
    setEditingIngredient(null);
    setForm({ name: "", quantity: "", unit: "" });
    setShowAddModal(true);
  };

  // Open edit modal with prefilled data
  const openEditModal = (ingredient) => {
    setEditingIngredient(ingredient);
    setForm({
      name: ingredient.name,
      quantity: ingredient.quantity,
      unit: ingredient.unit,
    });
    setShowAddModal(true);
  };

  const handleAddOrEditIngredient = async (e) => {
    e.preventDefault();
    try {
      if (editingIngredient) {
        // ✅ Update ingredient
        await axios.put(`${ApiUrl}/ingredients/${editingIngredient.id}`, form);
      } else {
        // ✅ Add new ingredient
        await axios.post(`${ApiUrl}/ingredients`, form);
      }
      fetchIngredients();
      setShowAddModal(false);
      setForm({ name: "", quantity: "", unit: "" });
      setEditingIngredient(null);
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (id) => {
    // if (!window.confirm("Are you sure you want to delete this ingredient?")) return;
    try {
      await axios.delete(`${ApiUrl}/ingredients/${id}`);
      fetchIngredients();
    } catch (err) {
      console.error(err);
    }
  };

  // Pagination logic for ingredients
  const indexOfLastIngredient = currentIngredientPage * ingredientsPerPage;
  const indexOfFirstIngredient = indexOfLastIngredient - ingredientsPerPage;
  const currentIngredients = ingredients.slice(indexOfFirstIngredient, indexOfLastIngredient);
  const totalIngredientPages = Math.ceil(ingredients.length / ingredientsPerPage);

  // Pagination logic for logs
  const indexOfLastLog = currentLogPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog);
  const totalLogPages = Math.ceil(logs.length / logsPerPage);

  const renderPagination = (currentPage, totalPages, setPage) => {
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(
        <button
          key={i}
          className={`px-2 py-1 rounded mx-1 ${
            i === currentPage ? "bg-blue-600 text-white" : "bg-gray-200"
          }`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }
    return pages;
  };

  return (
    <div className="p-6 transition-all duration-300 relative">
      <div className={`${showAddModal || showLogsModal ? "blur-sm" : ""}`}>
        <div className="flex justify-end items-center mb-6">
          <div className="flex gap-3">
            <button
              onClick={openLogsModal}
              className="flex items-center bg-indigo-600 text-white px-4 py-2 rounded-lg shadow hover:bg-indigo-700 transition"
            >
              <MdHistory className="mr-1" /> Logs
            </button>
            <button
              onClick={openAddModal}
              className="flex items-center bg-green-600 text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
            >
              <MdAdd className="mr-1" /> Add Ingredient
            </button>
          </div>
        </div>

        {/* Ingredients Table */}
        <div className="bg-white dark:bg-navy-800 shadow rounded-lg overflow-hidden">
          <table className="min-w-full table-auto">
            <thead className="bg-gray-100 dark:bg-navy-700">
              <tr>
                <th className="px-4 py-3 text-left">Name</th>
                <th className="px-4 py-3 text-left">Quantity</th>
                <th className="px-4 py-3 text-left">Unit</th>
                <th className="px-4 py-3 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentIngredients?.map((ing) => (
                <tr
                  key={ing.id}
                  className="border-b hover:bg-gray-50 dark:hover:bg-navy-700/50 transition"
                >
                  <td className="px-4 py-3">{ing.name}</td>
                  <td className="px-4 py-3">{ing.quantity}</td>
                  <td className="px-4 py-3">{ing.unit}</td>
                  <td className="px-4 py-3 text-right space-x-2">
                    <button
                      onClick={() => openEditModal(ing)}
                      className="text-yellow-500 hover:scale-110 transition"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => handleDelete(ing.id)}
                      className="text-red-500 hover:scale-110 transition"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
              {ingredients.length === 0 && (
                <tr>
                  <td colSpan="4" className="px-4 py-4 text-center text-gray-500">
                    No ingredients found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Ingredient Pagination */}
          {totalIngredientPages > 1 && (
            <div className="flex justify-end mt-2 mr-4 mb-3">
              {renderPagination(currentIngredientPage, totalIngredientPages, setCurrentIngredientPage)}
            </div>
          )}
        </div>
      </div>

      {/* Add/Edit Ingredient Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-navy-800 p-6 rounded-lg w-96 shadow-lg relative">
            <button
              onClick={() => setShowAddModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 dark:hover:text-white"
            >
              <MdClose size={22} />
            </button>
            <h3 className="text-lg font-bold mb-4">
              {editingIngredient ? "Edit Ingredient" : "Add Ingredient"}
            </h3>
            <form onSubmit={handleAddOrEditIngredient} className="space-y-4">
              <input
                type="text"
                placeholder="Name"
                className="w-full p-2 border rounded dark:bg-navy-700"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
              />
              <input
                type="number"
                placeholder="Quantity"
                className="w-full p-2 border rounded dark:bg-navy-700"
                value={form.quantity}
                onChange={(e) => setForm({ ...form, quantity: e.target.value })}
                required
              />
              <input
                type="text"
                placeholder="Unit (e.g., kg, g, pcs)"
                className="w-full p-2 border rounded dark:bg-navy-700"
                value={form.unit}
                onChange={(e) => setForm({ ...form, unit: e.target.value })}
                required
              />
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="button"
                  onClick={() => setShowAddModal(false)}
                  className="px-4 py-2 border rounded hover:bg-gray-100 dark:hover:bg-navy-700"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >
                  {editingIngredient ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Logs Modal */}
      {showLogsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-navy-800 p-6 rounded-lg w-[700px] max-h-[80vh] overflow-y-auto shadow-lg relative">
            <button
              onClick={() => setShowLogsModal(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 dark:hover:text-white"
            >
              <MdClose size={22} />
            </button>
            <h3 className="text-lg font-bold mb-4 flex items-center">
              <MdHistory className="mr-2" /> Ingredient Logs
            </h3>
            <table className="min-w-full table-auto">
              <thead className="bg-gray-100 dark:bg-navy-700">
                <tr>
                  <th className="px-4 py-2 text-left">Date</th>
                  <th className="px-4 py-2 text-left">Ingredient</th>
                  <th className="px-4 py-2 text-left">Change</th>
                  <th className="px-4 py-2 text-left">Reason</th>
                </tr>
              </thead>
              <tbody>
                {currentLogs.map((log, idx) => (
                  <tr
                    key={idx}
                    className="border-b hover:bg-gray-50 dark:hover:bg-navy-700/50 transition"
                  >
                    <td className="px-4 py-2">{new Date(log.createdAt).toLocaleString()}</td>
                    <td className="px-4 py-2">{log.Ingredient?.name || "-"}</td>
                    <td
                      className={`px-4 py-2 font-semibold ${
                        log.change > 0 ? "text-green-600" : "text-red-600"
                      }`}
                    >
                      {log.change > 0 ? `+${log.change}` : log.change}
                    </td>
                    <td className="px-4 py-2">{log.reason || "-"}</td>
                  </tr>
                ))}
                {logs.length === 0 && (
                  <tr>
                    <td colSpan="4" className="px-4 py-4 text-center text-gray-500">
                      No logs found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Logs Pagination */}
            {totalLogPages > 1 && (
              <div className="flex justify-center mt-2">
                {renderPagination(currentLogPage, totalLogPages, setCurrentLogPage)}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
